module.exports = __webpack_public_path__ + "img/IconMobile.4be026ac.svg";